
import { useState, useEffect, useRef, } from "react";
import { useContext, useMemo } from "react";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Transmitter from "../components/Transmitter";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import Valve from "../components/Valve";
import "./MainFractionationTowers2.css";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import { PumpContext } from "../context/PumpContext";
import { ProcessContext } from "../context/ProcessContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import MDSFaceplate from "../components/MDSFaceplate";
import LaboratoryAnalysisFaceplate from "../components/LaboratoryAnalysisFaceplate";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";
import MainFractionationLaboratory from "./MainFractionationLaboratory";

import VaporLiquidGrid from "../components/VaporLiquidGrid"; 


import { trackPageVisit } from "../competency/PageTracker";
import TransmitterFaceplate from "../components/TransmitterFaceplate";





function ValveOutput({
    tag,
    value,
    x,
    y,
    r = 0,
    description = "Control Valve Opening"
}) {

    const [hover, setHover] = useState(false);
    const [showFaceplate, setShowFaceplate] = useState(false);

    return (
        <>
            {/* Hover */}
            {hover && (
                <div
                    style={{
                        position: "absolute",
                        left: x + 30,
                        top: y - 5,
                        background: "rgba(0,80,180,.85)",
                        color: "#fff",
                        padding: "5px 8px",
                        borderRadius: "4px",
                        border: "1px solid #4fc3ff",
                        fontSize: "11px",
                        zIndex: 9999,
                        pointerEvents: "none",
                        whiteSpace: "nowrap"
                    }}
                >
                    <strong>{tag}</strong><br />
                    {description}
                </div>
            )}

            {/* Original Valve Output */}
            <div
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => setShowFaceplate(true)}
                style={{
                    position: "absolute",
                    left: x,
                    top: y,

                    color: "lime",
                    background: "black",

                    fontSize: "10px",
                    padding: "1px 4px",

                    borderRadius: "4px",
                    border: "1px solid #555",

                    transform: `rotate(${r}deg)`,
                    transformOrigin: "center",

                    cursor: "pointer",

                    fontWeight: "bold",

                    minWidth: "22px",
                    textAlign: "center",

                    transition: "0.2s",
                    boxShadow: hover
                        ? "0 0 8px rgba(0,255,255,.7)"
                        : "none"
                }}
            >
                {Number(value).toFixed(1)} %
            </div>

            {showFaceplate && (
                <TransmitterFaceplate
                    tag={tag}
                    value={Number(value)}
                    unit="%"
                    min={0}
                    max={100}
                    HH={100}
                    H={90}
                    L={10}
                    LL={0}
                    description={description}
                    x={x + 35}
                    y={y + 20}
                    onClose={() => setShowFaceplate(false)}
                />
            )}
        </>
    );
}




function MainFractionationTowers2() {

    useEffect(() => {
    
      trackPageVisit("MainFractionationTowers2");
    
    }, []);
  
     const {toggleValve, valves} = useContext(WellContext);

const [hoveredValve, setHoveredValve] = useState(null);
const [showLabReport, setShowLabReport] = useState(false);
const {processData,  setProcessData} = useContext(ProcessContext);


const openMainFractionationLab = () => {

    setShowLabReport(true);

};
     

  const DEFAULT_VALVES = {
  FCV_2301: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2302: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2303: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2304: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("MainFractionationTowers2_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_2301: { ...DEFAULT_VALVES.FCV_2301, ...parsed.FCV_2301 },
      FCV_2302: { ...DEFAULT_VALVES.FCV_2302, ...parsed.FCV_2302 },
      FCV_2303: { ...DEFAULT_VALVES.FCV_2303, ...parsed.FCV_2303 },
      FCV_2304: { ...DEFAULT_VALVES.FCV_2304, ...parsed.FCV_2304 },

    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("MainFractionationTowers2_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };


  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};






const tagStyle = {
      position: "absolute",
      top: -30,
      left: "50%",
      transform: "translateX(-50%)",

      background: "black",
      color: "#00ffcc",

      fontSize: "13px",
      fontWeight: "bold",

      padding: "3px 8px",
      borderRadius: "4px",

      border: "1px solid #555",

      whiteSpace: "nowrap",
      zIndex: 999
    };


// ================= RETREIVING OF DATA FROM OTHER PAGES VIA LOCAL STROAGE =================

  
   const { transmitters, flowOverrides} = usePlantStore();
    const FIC_2101 = transmitters.FIC_2101 || 0;
    const TT_2105 = transmitters.TT_2105 || 0;
    const PT_21010 = transmitters.PT_21010 || 0;
    const TT_2109 = transmitters.TT_2109 || 0;
    const PT_2109 = transmitters.PT_2109 || 0;


const FIC_2206 =
  Number(
    localStorage.getItem(
      "FIC_2206"
    )
  ) || 0;
  
const FIC_2204 =
  Number(
    localStorage.getItem(
      "FIC_2204"
    )
  ) || 0;

  const FIC_2205 =
  Number(
    localStorage.getItem(
      "FIC_2205"
    )
  ) || 0;

const TT_2205 =
  Number(
    localStorage.getItem(
      "TT_2205"
    )
  ) || 50;
  

  
const TT_2405 =
  Number(
    localStorage.getItem(
      "TT_2405"
    )
  ) || 32;
  
const FIC_2405 =
  Number(
    localStorage.getItem(
      "FIC_2405"
    )
  ) || 0;
  
const PT_2405 =
  Number(
    localStorage.getItem(
      "PT_2405"
    )
  ) || 0.03;
  


    const xv2301Open = !valves?.XV_2301;
    const xv2302Open = !valves?.XV_2302;



    const FIC_2301 = FIC_2101;
    const TT_2301 = TT_2105;
    const PT_2301 = PT_21010;

    const TT_2302 = TT_2109;
    const PT_2302 = PT_2109;
    const FIC_2302 = 13.54 * (valveData?.FCV_2302?.opening || 0)/50;


/* =========================================================
   REFLUX EFFECT
========================================================= */

const RefluxRatio =

  FIC_2301 > 0

    ?

    FIC_2205 /
    FIC_2301

    :

    0;

/*
Cold reflux suppresses
vaporization in upper tower
*/

const RefluxCoolingFactor =

  RefluxRatio *

  Math.max(
    0,
    (180 - TT_2205) / 100
  );

/* =========================================================
   STEAM EFFECT
========================================================= */

const SteamRatio =
  FIC_2301 > 0
    ? FIC_2302 / FIC_2301
    : 0;

/*
Steam strips lighter material
and cools the lower section
slightly.
*/

const SteamCooling =
  SteamRatio * 12;





/* =========================================================
   RETRIEVE PREFLASH BOTTOMS FLOW COMPOSITION
========================================================= */

const [FeedComposition, setFeedComposition] =
  useState({});


  useEffect(() => {

  const loadFeedComposition = () => {

    const data =
      JSON.parse(
        localStorage.getItem(
          "PreFlashBottomsFlowComposition"
        ) || "{}"
      );

    setFeedComposition(data);

  };

  loadFeedComposition();

  const timer =
    setInterval(
      loadFeedComposition,
      1000
    );

  return () =>
    clearInterval(timer);

}, []);





const LightNaphthaFeed =
  FeedComposition.LightNaphtha || 0;

const HeavyNaphthaFeed =
  FeedComposition.HeavyNaphtha || 0;

const KeroseneFeed =
  FeedComposition.Kerosene || 0;

const DieselFeed =
  FeedComposition.Diesel || 0;

const VGOFeed =
  FeedComposition.VGO || 0;

const ResidueFeed =
  FeedComposition.Residue || 0;



  

  console.log({
  LightNaphthaFeed,
  HeavyNaphthaFeed,
  KeroseneFeed,
  DieselFeed,
  VGOFeed,
  ResidueFeed
});





/* =========================================================
   ATMOSPHERIC TOWER FLASH ZONE MODEL
========================================================= */

/*
TT_2301
=
Furnace outlet temperature
entering flash zone

PT_2301
=
Flash zone pressure

FIC_2301
=
Crude feed rate
*/

/* =========================================================
   TEMPERATURE FACTOR
========================================================= */

let TemperatureFactor = 0;

if (TT_2301 < 250)
{
  TemperatureFactor = 0.25;
}
else if (TT_2301 < 300)
{
  TemperatureFactor = 0.45;
}
else if (TT_2301 < 340)
{
  TemperatureFactor = 0.65;
}
else if (TT_2301 < 360)
{
  TemperatureFactor = 0.85;
}
else
{
  TemperatureFactor = 1.00;
}

/* =========================================================
   PRESSURE FACTOR
========================================================= */

/*
Higher pressure suppresses flashing
*/

const PressureFactor =
  Math.max(
    0.50,
    1 -
    (
      PT_2301 * 0.03
    )
  );

/* =========================================================
   FLASH SEVERITY
========================================================= */
const FlashSeverity =

  TemperatureFactor *

  PressureFactor *

  Math.max(
    0.55,
    1 - RefluxCoolingFactor
  );



  /* =========================================================
   COMPONENT FLASHING
========================================================= */

const LightNaphthaFlash =
  Math.min(
    1.00,
    FlashSeverity * 1.50
  );

const HeavyNaphthaFlash =
  Math.min(
    1.00,
    FlashSeverity * 1.15
  );

const KeroseneFlash =
  Math.min(
    0.95,
    FlashSeverity * 0.80
  );

const DieselFlash =
  Math.min(
    0.75,
    FlashSeverity * 0.45
  );

const VGOFlash =
  Math.min(
    0.50,
    FlashSeverity * 0.18
  );

const ResidueFlash =
  Math.min(
    0.10,
    FlashSeverity * 0.02
  );






  /* =========================================================
   FLASH ZONE VAPOR
========================================================= */

const FlashZoneVaporComposition = {

  LightNaphtha:
    LightNaphthaFeed *
    LightNaphthaFlash,

  HeavyNaphtha:
    HeavyNaphthaFeed *
    HeavyNaphthaFlash,

  Kerosene:
    KeroseneFeed *
    KeroseneFlash,

  Diesel:
    DieselFeed *
    DieselFlash,

  VGO:
    VGOFeed *
    VGOFlash,

  Residue:
    ResidueFeed *
    ResidueFlash

};





/* =========================================================
   FLASH ZONE LIQUID
========================================================= */

const FlashZoneLiquidComposition = {

  LightNaphtha:
    LightNaphthaFeed -
    FlashZoneVaporComposition.LightNaphtha,

  HeavyNaphtha:
    HeavyNaphthaFeed -
    FlashZoneVaporComposition.HeavyNaphtha,

  Kerosene:
    KeroseneFeed -
    FlashZoneVaporComposition.Kerosene,

  Diesel:
    DieselFeed -
    FlashZoneVaporComposition.Diesel,

  VGO:
    VGOFeed -
    FlashZoneVaporComposition.VGO,

  Residue:
    ResidueFeed -
    FlashZoneVaporComposition.Residue

};





/* =========================================================
   TOTAL VAPOR FLOW
========================================================= */

const FlashZoneVaporFlow =
  Object.values(
    FlashZoneVaporComposition
  ).reduce(
    (a, b) => a + b,
    0
  );

/* =========================================================
   TOTAL LIQUID FLOW
========================================================= */

const FlashZoneLiquidFlow =
  Object.values(
    FlashZoneLiquidComposition
  ).reduce(
    (a, b) => a + b,
    0
  );




  // TEMPERATURE OR THERMAL DISTRIBUTION OF DISTILLATION TOWER AT THE BOTTOM


/* =========================================================
   MIDDLE TEMPERATURE
========================================================= */

const VaporCooling =
  FlashZoneVaporFlow * 0.8;

const RefluxTemperatureDrop =

  RefluxRatio * 25;

const TT_2309 =

  TT_2301 -

  VaporCooling -

  RefluxTemperatureDrop;


/* =========================================================
   DIESEL DRAW TRAY
========================================================= */

const DieselVaporFraction =
  FlashZoneVaporComposition.Diesel /
  Math.max(
    0.1,
    FlashZoneVaporFlow
  );

const FCV2301Opening =
  (valveData?.FCV_2301?.opening || 0) / 60;

/* ==========================================
   DIESEL DRAW VALVE EFFECT
========================================== */

const ValveTemperatureFactor =
  0.5 +
  (
    FCV2301Opening * 0.5
  );

/*
100% open = 1.00

50% open = 0.75

0% open = 0.50
*/

const ActualDieselTrayTemperature =

  TT_2309 -

  (
    20 -
    DieselVaporFraction * 10
  ) -

  (
    RefluxRatio * 12
  );

    /* =========================================================
   DIESEL STRIPPER RETURN
========================================================= */

const StripperHeatingEffect =
  FIC_2302 * 1.2;



/* ==========================================
   FINAL TT_2305
========================================== */

const TT_2305 =
  FlashZoneVaporFlow > 0.1
    ? (ActualDieselTrayTemperature *
      ValveTemperatureFactor + StripperHeatingEffect) * 0.86
    : 35;

const TT_2306 = TT_2405;


  /* =========================================================
   FLASH ZONE TEMPERATURE
========================================================= */

const KeroseneVaporFraction =
  FlashZoneVaporComposition.Kerosene /
  Math.max(
    0.1,
    FlashZoneVaporFlow
  );

const TT_2304 =
  TT_2305 + (TT_2305*0.014) -
  (
    KeroseneVaporFraction * 8
  );

    /* =========================================================
   bottom PRODUCT
========================================================= */

const SteamContribution =
  (
    (TT_2302 - TT_2309)
    *
    SteamRatio
    *
    0.25
  );

const TT_2303 =
  TT_2309 -
  10 +
  SteamContribution;


    /* =========================================================
   RESIDUE PRODUCT
========================================================= */

const TT_2307 =
  TT_2303 -
  5;





  localStorage.setItem(
  "FlashZoneVaporComposition",
  JSON.stringify(
    FlashZoneVaporComposition
  )
);

localStorage.setItem(
  "FlashZoneLiquidComposition",
  JSON.stringify(
    FlashZoneLiquidComposition
  )
);

localStorage.setItem(
  "FlashZoneVaporFlow",
  FlashZoneVaporFlow
);

localStorage.setItem(
  "StripperHeatingEffect",
  StripperHeatingEffect
);

localStorage.setItem(
  "FlashZoneLiquidFlow",
  FlashZoneLiquidFlow
);




console.log(
  "FLASH ZONE VAPOR",
  FlashZoneVaporComposition
);

console.log(
  "FLASH ZONE LIQUID",
  FlashZoneLiquidComposition
);

console.log(
  "FLASH ZONE VAPOR FLOW",
  FlashZoneVaporFlow
);

console.log(
  "FLASH ZONE LIQUID FLOW",
  FlashZoneLiquidFlow
);




/* =========================================================
   FRACTIONATION (TOWER) SECTION
========================================================= */

/*
Vapor stream rising upward
*/

let RisingVapor = {
  ...FlashZoneVaporComposition
};

/*
Liquid stream falling downward
*/

let FallingLiquid = {
  ...FlashZoneLiquidComposition
};






const KeroseneRecovery =
  Math.min(
    0.95,
    Math.max(
      0,
      (TT_2303 - 180) / 80
    )
  );



  const KeroseneProduct = {

  Kerosene:
    (
      RisingVapor.Kerosene +
      FallingLiquid.Kerosene
    ) *
    KeroseneRecovery,

  Diesel:
    (
      RisingVapor.Diesel +
      FallingLiquid.Diesel
    ) *
    0.05

};



const DieselRecovery =
  Math.min(
    0.95,
    Math.max(
      0,
      (TT_2304 - 240) / 100
    )
  );



  const DieselProduct = {

  Diesel:
    (
      RisingVapor.Diesel +
      FallingLiquid.Diesel
    ) *
    DieselRecovery,

  VGO:
    (
      RisingVapor.VGO +
      FallingLiquid.VGO
    ) *
    0.08

};




const FIC_2305 =

  (
    DieselProduct.Diesel +

    DieselProduct.VGO
  ) *

  FCV2301Opening;


const FIC_2306 =

  FIC_2405 *

  (
    0.03 +

    RefluxRatio * 0.10
  );



  

 const TowerVaporFlow = FlashZoneVaporFlow + FIC_2302 * 0.85;

  
 
 
 const VaporTrafficFactor =

  FIC_2301 > 0

  ?

  TowerVaporFlow /
  FIC_2301

  :

  0;



  const PT_2303 = PT_2301 + VaporTrafficFactor * 0.08 + SteamRatio * 0.05;
  const PT_2304 = PT_2301 - (VaporTrafficFactor * 0.04);
  const PT_2305 = PT_2304 - 0.01;
  const PT_2306 = PT_2405;
  
  





  const RemainingDiesel =

  Math.max(
    0,
    DieselFeed -
    FIC_2305
  );

const RemainingResidue =
  ResidueFeed;

const RemainingVGO =
  VGOFeed;




const RefluxRemoval =

  Math.min(
    0.70,
    RefluxRatio * 2
  );

const OverheadComposition = {

  LightNaphtha:
    RisingVapor.LightNaphtha,

  HeavyNaphtha:
    RisingVapor.HeavyNaphtha *

    (1 - RefluxRemoval * 0.35),

  Kerosene:
    RisingVapor.Kerosene *

    (0.10 - RefluxRemoval * 0.05)

};



const DieselProductTotal =

  DieselProduct.Diesel +

  DieselProduct.VGO;

const DieselProductComposition = {

  Diesel:

    DieselProductTotal > 0

      ?

      FIC_2305 *

      DieselProduct.Diesel /

      DieselProductTotal

      :

      0,

  VGO:

    DieselProductTotal > 0

      ?

      FIC_2305 *

      DieselProduct.VGO /

      DieselProductTotal

      :

      0

};

localStorage.setItem(

  "DieselProductComposition",

  JSON.stringify(
    DieselProductComposition
  )

);

const BottomsComposition = {

  LightNaphtha:
    FallingLiquid.LightNaphtha,

  HeavyNaphtha:
    FallingLiquid.HeavyNaphtha,

  Kerosene:
    Math.max(
      0,
      FallingLiquid.Kerosene -
      KeroseneProduct.Kerosene
    ),

  Diesel:
    Math.max(
      0,
      FallingLiquid.Diesel -
      DieselProduct.Diesel
    ),

  VGO:
    FallingLiquid.VGO,

  Residue:
    FallingLiquid.Residue

};

localStorage.setItem(
  "DieselProductComposition",
  JSON.stringify(
    DieselProduct
  )
);



const FIC_2307 = 

  RemainingDiesel +

  RemainingVGO +

  RemainingResidue;



  
/* =========================================================
   PUMP CONTEXT
========================================================= */

const pumpContext = useContext(PumpContext) || {};
const pumpData = pumpContext.pumpData || {};


/* =========================================================
   P-108A / P-108B STATUS
========================================================= */

const P108A_Running =
  pumpData?.["P-108A"]?.running ?? false;

const P108B_Running =
  pumpData?.["P-108B"]?.running ?? false;


/* =========================================================
   NUMBER OF RUNNING PUMPS
========================================================= */

const RunningPumps =
  (P108A_Running ? 1 : 0) +
  (P108B_Running ? 1 : 0);


/* =========================================================
   TOTAL CAPACITY
========================================================= */

const P108_CAPACITY =
  RunningPumps * 15;


/* =========================================================
   FCV-2303 OPENING
========================================================= */

const FCV2303_Opening =
  (valveData?.FCV_2303?.opening || 0) / 100;


/* =========================================================
   TARGET FLOW
========================================================= */

const targetFIC_2308 =
  P108_CAPACITY *
  FCV2303_Opening;


/* =========================================================
   FIC-2308
========================================================= */

const FIC_2308 = flowOverrides?.FIC_2308 ? 0 : (processData.FIC_2308 || 0);

useEffect(() => {

  const lastUpdate =
    Number(
      localStorage.getItem(
        "FIC_2308_LastUpdate"
      )
    ) || Date.now();

  const elapsedSeconds =
    (Date.now() - lastUpdate) / 1000;

  if (elapsedSeconds <= 1) return;

  setProcessData(prev => {

    const current =
      Number(prev.FIC_2308 || 0);

    let next = current;

    const systemActive =
      P108A_Running ||
      P108B_Running;

    const target =
      systemActive
        ? targetFIC_2308
        : 0;

    /* ====================================
       MAXIMUM 100 SCANS
       ==================================== */

    const scans =
      Math.min(
        Math.floor(
          elapsedSeconds * 10
        ),
        100
      );

    for (
      let i = 0;
      i < scans;
      i++
    ) {

      next =
        next +
        (
          target -
          next
        ) * 0.12;

    }

    return {
      ...prev,
      FIC_2308: Number(
        next.toFixed(3)
      )
    };

  });

}, [
  targetFIC_2308,
  P108A_Running,
  P108B_Running
]);



useEffect(() => {

  localStorage.setItem(
    "FIC_2308_LastUpdate",
    String(Date.now())
  );

}, [FIC_2308]);




useEffect(() => {

  const timer = setInterval(() => {

    setProcessData(prev => {

      const current =
        Number(prev.FIC_2308 || 0);

      const target =
        Number(targetFIC_2308 || 0);

      const next =
        current +
        (target - current) * 0.12;

      return {
        ...prev,
        FIC_2308: Number(next.toFixed(3))
      };

    });

  }, 500);

  return () => clearInterval(timer);

}, [targetFIC_2308]);



/* =========================================================
   PT-2308
========================================================= */

let targetPT_2308 = 0.03;

if (
  RunningPumps > 0 &&
  FCV2303_Opening >= 0.30
) {

  targetPT_2308 = 1.3;

}

/* ==========================================
   RESTRICTED FLOW REGION
========================================== */

else if (
  RunningPumps > 0 &&
  FCV2303_Opening > 0 &&
  FCV2303_Opening < 0.28
) {

  const restrictionFactor =
    (0.28 - FCV2303_Opening) / 0.28;

  targetPT_2308 =
    1.8 -
    (restrictionFactor * 0.8);

}


/* =========================================================
   PT-2308 ACTUAL
========================================================= */

const PT_2308 =
  Number(
    targetPT_2308.toFixed(3)
  );


  const atmosphericTemperature = 25;
/* =========================================================
   TT-2308
========================================================= */

let targetTT_2308 =
  Number(
    atmosphericTemperature || 29
  );


if (
  RunningPumps > 0 &&
  FCV2303_Opening >= 0.30
) {

  targetTT_2308 =
    Number(TT_2307 || 29);

}

/* ==========================================
   RESTRICTED FLOW REGION
========================================== */

else if (
  RunningPumps > 0 &&
  FCV2303_Opening > 0 &&
  FCV2303_Opening < 0.28
) {

  const restrictionFactor =
    (0.28 - FCV2303_Opening) / 0.28;

  targetTT_2308 =
    Number(TT_2307 || 29)
    +
    (
      restrictionFactor * 18
    );

}


/* =========================================================
   TT-2308 ACTUAL
========================================================= */

const TT_2308 =
  Number(
    targetTT_2308.toFixed(2)
  );




  localStorage.setItem(
  "KeroseneProduct",
  JSON.stringify(
    KeroseneProduct
  )
);

  localStorage.setItem(
  "OverheadComposition",
  JSON.stringify(
    OverheadComposition
  )
);
  localStorage.setItem(
  "FlashZoneLiquidFlow ",
  JSON.stringify(
    FlashZoneLiquidFlow 
  )
);


  localStorage.setItem(
  "FIC_2305",
  FIC_2305
);

  localStorage.setItem(
  "TT_2305",
  TT_2305
);

  localStorage.setItem(
  "PT_2305",
  PT_2305
);

localStorage.setItem(
  "FIC_2306",
  FIC_2306
);

localStorage.setItem(
  "FIC_2307",
  FIC_2307
);





localStorage.setItem(
  "TT_2304",
  TT_2304
);

localStorage.setItem(
  "TT_2306",
  TT_2306
);

localStorage.setItem(
  "TT_2309",
  TT_2309
);

localStorage.setItem(
  "FIC_2301",
  FIC_2301
);

localStorage.setItem(
  "PT_2304",
  PT_2304
);


localStorage.setItem(
  "FlashSeverity",
  FlashSeverity
);

localStorage.setItem(
  "FlashZoneVaporFlow",
  FlashZoneVaporFlow
);

localStorage.setItem(
  "FlashZoneVaporComposition",
  JSON.stringify(
    FlashZoneVaporComposition
  )
);

localStorage.setItem(
  "FlashZoneLiquidComposition",
  JSON.stringify(
    FlashZoneLiquidComposition
  )
);





useEffect(() => {

  const current =
    PlantStore.get().transmitters;


  if (
    current.FIC_2308 === FIC_2308 &&
    current.TT_2308 === TT_2308 &&
    current.PT_2308 === PT_2308
  ) {
    return;
  }


  PlantStore.set({
    transmitters: {

      ...current,
      FIC_2308, TT_2308, PT_2308
    }
  });

}, [FIC_2308, TT_2308, PT_2308]);




/* =========================================================
   SAVE BOTTOM SECTION FOR LAB REPORT
========================================================= */

const MainFractionationBottomReport = {

    generated: new Date().toLocaleString(),

    feed: {

        flow: FIC_2301,
        temperature: TT_2301,
        pressure: PT_2301,

        composition: FeedComposition

    },

    operation: {

        refluxRatio: RefluxRatio,
        steamRatio: SteamRatio,
        flashSeverity: FlashSeverity

    },

    flashZone: {

        vaporFlow: FlashZoneVaporFlow,
        liquidFlow: FlashZoneLiquidFlow,

        vaporComposition:
            FlashZoneVaporComposition,

        liquidComposition:
            FlashZoneLiquidComposition

    },

    tower: {

        flashZone: {

            temperature: TT_2309,
            pressure: PT_2303

        },

        bottom: {

            temperature: TT_2307,
            pressure: PT_2308

        }

    },

    bottoms: {

        flow: FIC_2307,

        composition:
            BottomsComposition

    },

    sideDraws: {

        diesel: {

            flow: FIC_2305,

            composition:
                DieselProductComposition

        }

    },

    performance: {

        flashSeverity: FlashSeverity,
        vaporFlow: FlashZoneVaporFlow,
        liquidFlow: FlashZoneLiquidFlow

    }

};

localStorage.setItem(
    "MAIN_FRACTIONATION_BOTTOM",
    JSON.stringify(
        MainFractionationBottomReport
    )
);



  return (
    <div className="MainFractionationTowers2-container">

      {/* TITLE */}
      <h2
        style={{
          position: "absolute",
          top: "0px",
          left: "240px",
          color: "white",
          background: "rgb(30, 5, 250)",
          padding: "2px 303px",
          zIndex: 10,
        }}
      >
        FRACTIONATION TOWER (TOP)
      </h2>


 {/* =================SHUTDOWN VALVES ================= */}



      {/* XV-2301 */}
      <Valve
        className="XV-2301"
        tag="XV_2301"
        x={482}
        y={523}
        isClosed={valves.XV_2301}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-2302 */}
      <Valve
        className="XV-2302"
        tag="XV_2302"
        x={1055}
        y={114}
        isClosed={valves.XV_2302}
        toggle={toggleValve}
      />


 
        <button
          onClick={openMainFractionationLab}
          style={{
              position: "absolute",
              right: "300px",
              top: "300px",
              padding: "8px 16px",
              background: "#0b5ed7",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontWeight: "bold",
              zIndex: 9999
          }}
      >
          🧪 Main Tower Report
      </button>


      {
        showLabReport && (
        <MainFractionationLaboratory
            onClose={() => setShowLabReport(false)}
        />
        )
        }


      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-2301 */}
        <div
            style={{ position: "absolute", left: 938, top: 196}}
            onMouseEnter={() => setHoveredValve("FCV_2301")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_2301")}
          >

            {hoveredValve === "FCV_2301" && (
              <div style={tagStyle}>
                FCV_2301
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2301">
                    
          <defs>
            <linearGradient id="metal_2301">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2301)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2301)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      

       

        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-2302 */}
        <div
            style={{ position: "absolute", left: 410, top: 364}}
            onMouseEnter={() => setHoveredValve("FCV_2302")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_2302")}
          >

            {hoveredValve === "FCV_2302" && (
              <div style={tagStyle}>
                FCV_2302
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2302">
                    
          <defs>
            <linearGradient id="metal_2302">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2302)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2302)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-2304 */}
        <div
            style={{ position: "absolute", left: 1031, top: 480}}
            onMouseEnter={() => setHoveredValve("FCV_2303")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_2303")}
          >

            {hoveredValve === "FCV_2303" && (
              <div style={tagStyle}>
                FCV_2303
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2303">
                    
          <defs>
            <linearGradient id="metal_2303">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2303)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2303)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      



     
       

        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

           {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}



 {/* ================= CONTROL VALVE OUTPUTS ================= */}


      <ValveOutput
        value={Number(valveData?.FCV_2301?.opening || 0)}
        x={960}
        y={243}
      />
    
      <ValveOutput
        value={Number(valveData?.FCV_2302?.opening || 0)}
        x={432}
        y={413}
      />

      <ValveOutput
        value={Number(valveData?.FCV_2303?.opening || 0)}
        x={1052}
        y={527}
      />









        <Transmitter
          tag="FIC_2301"
          value={[FIC_2301]}
          x={162}
          y={256}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF FLASHED CRUDE FROM FURNACE (F-101) AT THE CONVECTION ZONE 1 & 2 TO FLASH ZONE OF DISTILLATION TOWER"
         />

        <Transmitter
          tag="PT_2301"
          value={[PT_2301]}
          x={262}
          y={256}
          unit="MPa"
          max={3}
          HH={2.8}
          H={1.5}
          L={0}
          LL={0}
          c="lime"
          description="PRESSURE OF FLASHED CRUDE FROM FURNACE (F-101) AT THE CONVECTION ZONE 1 & 2 TO FLASH ZONE OF DISTILLATION TOWER"
         />

        <Transmitter
          tag="TT_2301"
          value={[TT_2301]}
          x={362}
          y={256}
          unit="°C"
          max={450}
          HH={420}
          H={395}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF FLASHED CRUDE FROM FURNACE (F-101) AT THE CONVECTION ZONE 1 & 2 TO FLASH ZONE OF DISTILLATION TOWER"
         />

        <Transmitter
          tag="PT_2302"
          value={[PT_2302]}
          x={162}
          y={356}
          unit="MPa"
          max={3}
          HH={2.8}
          H={1.5}
          L={0}
          LL={0}
          c="lime"
          description="PRESSURE OF SUPERHEATED STEAM FROM FURNACE (F-101) AT THE CONVECTION ZONE 1 & 2 TO BOTTOM STRIPPING ZONE OF DISTILLATION TOWER"
         />

        <Transmitter
          tag="TT_2302"
          value={[TT_2302]}
          x={262}
          y={356}
          unit="°C"
          max={600}
          HH={580}
          H={555}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF SUPERHEATED STEAM FROM FURNACE (F-101) AT THE CONVECTION ZONE 1 & 2 TO BOTTOM STRIPPING ZONE OF DISTILLATION TOWER"
         />

        <Transmitter
          tag="TT_2303"
          value={[TT_2303]}
          x={492}
          y={306}
          unit="°C"
          max={600}
          HH={580}
          H={555}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF BOTTOM SECTION OF DISTILLATION TOWER"
         />

         <Transmitter
          tag="PT_2303"
          value={[PT_2303]}
          x={492}
          y={344}
          unit="MPa"
          max={3}
          HH={2.8}
          H={1.5}
          L={0}
          LL={0}
          c="lime"
          description="PRESSURE OF BOTTOM SECTION OF DISTILLATION TOWER"
         />

        <Transmitter
          tag="TT_2304"
          value={[TT_2304]}
          x={492}
          y={96}
          unit="°C"
          max={600}
          HH={580}
          H={555}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF MIDDLE SECTION OF DISTILLATION TOWER"
         />

         <Transmitter
          tag="PT_2304"
          value={[PT_2304]}
          x={402}
          y={96}
          unit="MPa"
          max={3}
          HH={2.8}
          H={1.5}
          L={0}
          LL={0}
          c="lime"
          description="PRESSURE OF MIDDLE SECTION OF DISTILLATION TOWER"
         />


        <Transmitter
          tag="TT_2306"
          value={[TT_2306]}
          x={742}
          y={106}
          unit="°C"
          max={600}
          HH={580}
          H={555}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF DIESEL GAS RETURN TO DISTILLATION TOWER"
         />

          <Transmitter
          tag="PT_2306"
          value={[PT_2306]}
          x={842}
          y={106}
          unit="MPa"
          max={3}
          HH={2.8}
          H={1.5}
          L={0}
          LL={0}
          c="lime"
          description="PRESSURE OF DIESEL GAS RETURN TO DISTILLATION TOWER"
         />

         <Transmitter
          tag="FIC_2306"
          value={[FIC_2306]}
          x={942}
          y={106}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF DIESEL GAS RETURN TO DISTILLATION TOWER"
         />


        <Transmitter
          tag="TT_2305"
          value={[TT_2305]}
          x={742}
          y={193}
          unit="°C"
          max={600}
          HH={580}
          H={555}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF DIESEL DRAW FROM DISTILLATION TOWER TO DIESEL STRIPPER"
         />

         <Transmitter
          tag="PT_2305"
          value={[PT_2305]}
          x={842}
          y={193}
          unit="MPa"
          max={3}
          HH={2.8}
          H={1.5}
          L={0}
          LL={0}
          c="lime"
          description="PRESSURE OF DIESEL DRAW FROM DISTILLATION TOWER TO DIESEL STRIPPER"
         />

         <Transmitter
          tag="FIC_2305"
          value={[FIC_2305]}
          x={1042}
          y={193}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF DIESEL DRAW FROM DISTILLATION TOWER TO DIESEL STRIPPER"
         />

        <Transmitter
          tag="TT_2307"
          value={[TT_2307]}
          x={632}
          y={453}
          unit="°C"
          max={600}
          HH={580}
          H={555}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF RESIDUE DRAW FROM BOTTOM OF DISTILLATION TOWER TO  RESIDUE PUMPS (P-108A/B)"
         />


        <Transmitter
          tag="TT_2308"
          value={[TT_2308]}
          x={922}
          y={573}
          unit="°C"
          max={600}
          HH={580}
          H={555}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF RESIDUE DRAW FROM BOTTOM OF DISTILLATION TOWER THROUGH RESIDUE PUMPS (P-108A/B) TO E-118A/B"
         />

         <Transmitter
          tag="FIC_2308"
          value={[FIC_2308]}
          x={1112}
          y={473}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF RESIDUE DRAW FROM BOTTOM OF DISTILLATION TOWER THROUGH RESIDUE PUMPS (P-108A/B) TO E-118A/B"
         />

         <Transmitter
          tag="PT_2308"
          value={[PT_2308]}
          x={782}
          y={593}
          unit="MPa"
          max={3}
          HH={2.8}
          H={1.5}
          L={0}
          LL={0}
          c="lime"
          description="PRESSURE OF RESIDUE DRAW FROM BOTTOM OF DISTILLATION TOWER THROUGH RESIDUE PUMPS (P-108A/B) TO E-118A/B"
         />





            <LevelTransmitterIndicator
              tag="LT_2301"
              totalLevel={500}
              inflows={[FIC_2307]}
              outflows={[FIC_2308]}
              inflowTags={["FIC_2307"]}
              outflowTags={["FIC_2308"]}
              responseFactor={0.05}
              columnX={584}
              columnY={260}
              columnWidth={70}
              columnHeight={164}
              textX={666}
              textY={300}
              showFlow={true}
              backgroundOpacity={0.00}
              liquidOpacity={0.7}
              service="residue"
            />


            <Pump
              tag="P-108A"
              x={676}
              y={546}
              rpm={1800}
              bladeCount={pumpData?.["P-108A"]?.bladeCount || 3}
              size={pumpData?.["P-108A"]?.size || 50}
              onClick={openPumpPanel}
            />

            <Pump
              tag="P-108B"
              x={675}
              y={636}
              rpm={1800}
              bladeCount={pumpData?.["P-108B"]?.bladeCount || 3}
              size={pumpData?.["P-108B"]?.size || 50}
              onClick={openPumpPanel}
            />


    

    </div>
  );
}

export default MainFractionationTowers2;
